import { useEffect } from "react";

const useOutsideClick = (ref, callback) => {
   const handleClick = (e) => {
      // Ignore clicks on mobile-menu elements
      if (e.target.closest(".mobile-menu") || e.target.closest("#mobile-collapse")) {
         return;
      }

      if (ref.current && !ref.current.contains(e.target)) {
         callback();
      }
   };

   useEffect(() => {
      document.addEventListener("click", handleClick);
      return () => {
         document.removeEventListener("click", handleClick);
      };
   });
};

export default useOutsideClick;
